<div mat-dialog-content>
  <div class="mat-dialog-content">
    <div class="head-first-access-modal">
      @if (!isExpiredPassword) {
        <h2>Primeiro Acesso</h2>
      }
      @if (isExpiredPassword) {
        <h2>Senha Expirada! Troque para continuar.</h2>
      }
    </div>
    <div class="body-first-access-modal">
      <form class="form" [formGroup]="model" (ngSubmit)="submit()">
        <div class="row">
          <div class="col-md-12">
            <mat-form-field appearance="outline">
              @if (!isExpiredPassword) {
                <mat-label>Senha Temporária</mat-label>
              }
              @if (isExpiredPassword) {
                <mat-label>Senha Antiga</mat-label>
              }
              <mat-icon matSuffix (click)="hideOld = !hideOld">{{hideOld ? 'visibility_off' : 'visibility'}}</mat-icon>
              <input  matInput #oldPassword [type]="hideOld ? 'password' : 'text'" formControlName="oldPassword" required>
              @if (model.get('oldPassword').invalid && !isExpiredPassword) {
                <mat-error>Informe a senha temporária</mat-error>
              }
              @if (model.get('oldPassword').invalid && isExpiredPassword) {
                <mat-error>Informe a senha antiga</mat-error>
              }
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <mat-form-field appearance="outline">
              <mat-label>Nova senha</mat-label>
              <mat-icon matSuffix (click)="hideNew = !hideNew">{{hideNew ? 'visibility_off' : 'visibility'}}</mat-icon>
              <input #newPassword matInput [type]="hideNew ? 'password' : 'text'" formControlName="newPassword" required>
              @if (model.get('newPassword').invalid && !model.get('repetedPassword').getError('invalidPassword')) {
                <mat-error>Informe a nova senha</mat-error>
              }
              @if (model.get('newPassword').getError('invalidPassword')) {
                <mat-error>{{ model.get('newPassword').getError('invalidPassword').message}}</mat-error>
              }
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <mat-form-field appearance="outline">
              <mat-label>Repetir senha</mat-label>
              <mat-icon matSuffix (click)="hideNewRepeat = !hideNewRepeat">{{hideNewRepeat ? 'visibility_off' : 'visibility'}}</mat-icon>
              <input matInput #newPasswordRepeat [type]="hideNewRepeat ? 'password' : 'text'" formControlName="repetedPassword" required>
              @if (model.get('repetedPassword').invalid && !model.get('repetedPassword').getError('invalidPassword')) {
                <mat-error>Informe a nova senha</mat-error>
              }
              @if (model.get('repetedPassword').getError('invalidPassword')) {
                <mat-error>{{ model.get('repetedPassword').getError('invalidPassword').message}}</mat-error>
              }
            </mat-form-field>
            <p [ngStyle]="{ 'color': model.get('newPassword').invalid ? '#fc0303' : '#000000' }">Use entre oito ou mais caracteres, com uma combinação de letras maiúsculas, letras minúsculas, números e caracteres especiais.</p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <button mat-flat-button type="submit" color="primary" class=" btn-block">
              @if (isLoading == false) {
                <span>Salvar</span>
              }
              @if (isLoading == true) {
                <mat-spinner [diameter]="30" class="mat-spinner-btn">
                </mat-spinner>
              }
            </button>
          </div>
          <div class="col-md-6">
            <a mat-flat-button type="button" color="accent" class=" btn-block" (click)="clickCancel()">
              Cancelar
            </a>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>